<script>
    export default {
        props: {
            app: { required: true, type: Object },
            admin: { required: true, type: Object },
        },
    };
</script>
<template>
    <!-- Use $route.path (not fullPath) to avoid remounting on query-param changes (sort, page, search) -->
    <router-view :key="$route.path"></router-view>
</template>
